import { UUID_REGEX } from './regex';

const hasObjectValues = (obj: Record<string, unknown>): boolean => {
  return Object.values(obj).length > 0;
};

const hasObjectKeys = (obj: Record<string, unknown>): boolean => {
  return Object.keys(obj).length > 0;
};

export const objectUtils = (obj: Record<string, unknown>) => {
  const object = obj;

  return {
    isEmpty: () => !hasObjectValues(object) && !hasObjectKeys(object),
    keyCount: () => Object.keys(object).length,
    clearValuesFrom: (keys: string[]) => {
      keys.forEach((key) => {
        object[key] = undefined;
      });
    },
  };
};

export const isUuid = (str?: string) => typeof str === 'string' && UUID_REGEX.test(str);

const isUuidZero = (str?: string) => str === '00000000-0000-0000-0000-000000000000';

export const isValidId = (str?: string) => isUuid(str) && !isUuidZero(str);

export const areObjectsEqual = (obj1: Record<string, unknown>, obj2: Record<string, unknown>): boolean => {
  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  if (keys1.length !== keys2.length) {
    return false;
  }

  for (const key of keys1) {
    if (!(key in obj2)) {
      return false;
    }

    if (obj1[key] !== obj2[key]) {
      return false;
    }
  }

  return true;
};
